import type { LandingContent } from '../domain/landing.types'

export const landingContent: LandingContent = {
  navigation: [
    { label: 'Nosotros', href: '#nosotros' },
    { label: 'Productos', href: '#productos' },
    { label: 'Mayoreo', href: '#volumen' },
    { label: 'Cómo trabajamos', href: '#como-trabajamos' },
  ],
  hero: {
    eyebrow: 'SEMILLAS SELECCIONADAS. DESDE 1 KG HASTA TONELADAS.',
    title: 'CALIDAD QUE NUTRE NEGOCIOS Y PERSONAS.',
    description: 'Pistache, almendra, matcha japonés, cacao y más. Compra la cantidad que necesitas con precios competitivos que mejoran conforme crece tu volumen.',
    actions: [
      { label: 'Ver productos', href: '#productos', isPrimary: true },
      { label: 'Solicitar cotización', href: '#cotizar', isPrimary: false },
    ],
  },
  proofPoints: [
    { kicker: 'DESDE 1 KG', title: 'Compra lo que necesitas', description: 'Menudeo y volumen dentro de una misma experiencia, sin obligarte a comprar de más.' },
    { kicker: 'MEJOR PRECIO POR VOLUMEN', title: 'Tu escala trabaja a tu favor', description: 'A mayor volumen, mejores condiciones comerciales para tu compra.' },
    { kicker: 'LOGÍSTICA', title: 'Entrega con seguimiento', description: 'Coordinación de acuerdo con producto, cantidad, destino y necesidad.' },
    { kicker: 'CALIDAD', title: 'Selección por lote', description: 'Criterios claros de producto y trazabilidad preparados para una operación de alto estándar.' },
  ],
  purchaseScale: {
    eyebrow: 'MAYOREO Y SUMINISTRO',
    title: 'MÁS VOLUMEN. MEJORES CONDICIONES.',
    description: 'Compra desde la cantidad que necesitas. Conforme crecen tu volumen o la continuidad de tu operación, podemos estructurar mejores condiciones comerciales de acuerdo con producto, disponibilidad y destino.',
    milestones: [
      { label: '1 KG', supportingLabel: 'Menudeo', emphasis: 1 },
      { label: '10 KG', supportingLabel: 'Más producto', emphasis: 2 },
      { label: '20 KG', supportingLabel: 'Costal', emphasis: 3 },
      { label: '100 KG', supportingLabel: 'Negocio', emphasis: 4 },
      { label: '500 KG', supportingLabel: 'Mayoreo', emphasis: 5 },
      { label: '1 TON+', supportingLabel: 'Gran volumen', emphasis: 6 },
    ],
    closingStatement: 'La escala importa. La continuidad también.',
  },
  process: [
    { order: 1, title: 'Selección', description: 'Elegimos producto con criterios definidos de calidad y condición.' },
    { order: 2, title: 'Control', description: 'Revisamos cada lote antes de incorporarlo a la operación.' },
    { order: 3, title: 'Almacenamiento', description: 'Protegemos el producto con disciplina operativa y trazabilidad.' },
    { order: 4, title: 'Distribución', description: 'Coordinamos la entrega de acuerdo con volumen, destino y necesidad.' },
  ],
  productCategories: [
    { name: 'Pistache', description: 'Compra desde 1 kg y escala tu pedido conforme crece tu necesidad.', availabilityNote: 'Disponible desde 1 kg' },
    { name: 'Almendra', description: 'Presentaciones pensadas para menudeo, negocio y compra por volumen.', availabilityNote: 'Menudeo y volumen' },
    { name: 'Matcha japonés', description: 'Matcha japonés para bebidas, repostería y aplicaciones comerciales, sujeto a disponibilidad.', availabilityNote: 'Origen y calidad seleccionados' },
    { name: 'Cacao y café', description: 'Alimentos con identidad, origen y una propuesta preparada para crecer.', availabilityNote: 'Disponibilidad por categoría' },
  ],
  volumeOffer: {
    eyebrow: 'CONTINUIDAD',
    title: 'TU VOLUMEN NO SIEMPRE TIENE QUE LLEGAR EN UNA SOLA ENTREGA.',
    description: 'Una necesidad puntual puede resolverse con una sola compra. Cuando tu operación requiere continuidad, podemos estructurar un esquema de suministro acorde con tu consumo, frecuencia y logística.',
    relationshipTitle: 'COMPRAR UNA VEZ O CONSTRUIR SUMINISTRO.',
    modes: [
      {
        order: 1,
        title: 'Compra puntual',
        description: 'Para una necesidad específica de producto y volumen, con condiciones definidas para esa operación.',
      },
      {
        order: 2,
        title: 'Suministro recurrente',
        description: 'Para operaciones que buscan continuidad, planeación y condiciones comerciales construidas alrededor de su consumo.',
      },
    ],
  },
}
